export default __webpack_public_path__ + "static/media/08-Dhruvil-Rana.d57f0c7a.png";